import MyAlgoConnect from './Stub_MAC.mjs';
export default MyAlgoConnect;
//# sourceMappingURL=ALGO_MyAlgoConnect.js.map
